import { render, staticRenderFns } from "./BudgetGroup.vue?vue&type=template&id=142a804b&"
import script from "./BudgetGroup.vue?vue&type=script&lang=js&"
export * from "./BudgetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports